// extracted by mini-css-extract-plugin
export default {"title":"SectionTitle-module__title","link":"SectionTitle-module__link"};